module.exports = __webpack_public_path__ + "img/map2.d4cd2a0a.jpg";